/** UI tab — not an API field. */
export enum PlansPlanMode {
  REBALANCE = 'REBALANCE',
  ALLOCATION = 'ALLOCATION',
  IDEAL_PORTFOLIO = 'IDEAL_PORTFOLIO'
}

export enum PlansActionFilter {
  ALL = 'ALL',
  SELL = 'SELL',
  BUY = 'BUY',
  IN_REVIEW = 'IN_REVIEW',
  NO_ACTION = 'NO_ACTION',
  COMPLETED = 'COMPLETED',
  INVALIDATED = 'INVALIDATED'
}

/** UI toggle on allocation category list sticky bar — not an API field. */
export enum AllocationMovementToggle {
  ALLOCATION_MOVEMENT = 'ALLOCATION_MOVEMENT',
  FUND_MOVEMENT = 'FUND_MOVEMENT'
}

export const ALLOCATION_MOVEMENT_TOGGLE_OPTIONS: AllocationMovementToggle[] = [
  AllocationMovementToggle.ALLOCATION_MOVEMENT,
  AllocationMovementToggle.FUND_MOVEMENT
]

export const ALLOCATION_MOVEMENT_TOGGLE_LABELS: Record<AllocationMovementToggle, string> = {
  [AllocationMovementToggle.ALLOCATION_MOVEMENT]: 'Allocation movement',
  [AllocationMovementToggle.FUND_MOVEMENT]: 'Fund movement'
}

/** Matches backend category array keys. */
export enum PlanCategoryBucketKey {
  sellRecommendations = 'sellRecommendations',
  buyRecommendations = 'buyRecommendations',
  underReviewRecommendations = 'underReviewRecommendations',
  executedRecommendations = 'executedRecommendations',
  invalidatedRecommendations = 'invalidatedRecommendations',
  noActionFunds = 'noActionFunds'
}

export const PLAN_ACTION_FILTER_BUCKET: Partial<Record<PlansActionFilter, PlanCategoryBucketKey>> = {
  [PlansActionFilter.SELL]: PlanCategoryBucketKey.sellRecommendations,
  [PlansActionFilter.BUY]: PlanCategoryBucketKey.buyRecommendations,
  [PlansActionFilter.IN_REVIEW]: PlanCategoryBucketKey.underReviewRecommendations,
  [PlansActionFilter.NO_ACTION]: PlanCategoryBucketKey.noActionFunds,
  [PlansActionFilter.COMPLETED]: PlanCategoryBucketKey.executedRecommendations,
  [PlansActionFilter.INVALIDATED]: PlanCategoryBucketKey.invalidatedRecommendations
}

export const PLAN_INVALIDATED_SUBSECTION_ORDER = [
  'underReview',
  'buy',
  'sell',
  'misc'
] as const

export type PlanInvalidatedSubsectionKey = (typeof PLAN_INVALIDATED_SUBSECTION_ORDER)[number]

export const PLAN_INVALIDATED_SUBSECTION_TITLES: Record<PlanInvalidatedSubsectionKey, string> = {
  underReview: 'No longer under review',
  buy: 'No longer under Buy',
  sell: 'No longer under Sell',
  misc: 'Misc.'
}

export const PLAN_CATEGORY_BUCKET_TITLES: Record<PlanCategoryBucketKey, string> = {
  [PlanCategoryBucketKey.sellRecommendations]: 'Funds to Sell',
  [PlanCategoryBucketKey.buyRecommendations]: 'Funds to Buy',
  [PlanCategoryBucketKey.underReviewRecommendations]: 'Under Review',
  [PlanCategoryBucketKey.executedRecommendations]: 'Completed',
  [PlanCategoryBucketKey.invalidatedRecommendations]: 'No longer under this plan',
  [PlanCategoryBucketKey.noActionFunds]: 'Funds need no change'
}

/** Allocation tab titles. Rebalance keeps PLAN_CATEGORY_BUCKET_TITLES. */
export const ALLOCATION_CATEGORY_BUCKET_TITLES: Record<PlanCategoryBucketKey, string> = {
  ...PLAN_CATEGORY_BUCKET_TITLES,
  [PlanCategoryBucketKey.underReviewRecommendations]: 'Sell later'
}
